"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./BetOKTrendUtils";

export default function BetOKCorrectScoresSection({ title, correctScoresFull }) {
  const { home = [], draw = [], away = [] } = correctScoresFull || {};
  const allScores = [...home, ...draw, ...away];

  if (allScores.length === 0) return null;

  return (
    <div className="kbv-v24-odt-item kbv-v24-odt-item--100">
      <div className="kbv-v24-odt-title">
        <span>{title}</span>
      </div>
      <div className="kbv-v24-odt-odds-list kbv-v24-odt-scores-grid">
        {home.map((item, i) => (
          <div key={`h${i}`}>
            <div className="kbv-v24-odt-label">{item.label}</div>
            <div className="kbv-v24-odt-score-values">
              <div className={`kbv-v24-odt-odds ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div className={`kbv-v24-odt-odds ${trendClass(item.trend2)}`}>
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        {draw.map((item, i) => (
          <div key={`d${i}`}>
            <div className="kbv-v24-odt-label">{item.label}</div>
            <div className="kbv-v24-odt-score-values">
              <div className={`kbv-v24-odt-odds ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
            </div>
          </div>
        ))}
        {away.map((item, i) => (
          <div key={`a${i}`}>
            <div className="kbv-v24-odt-label">{item.label}</div>
            <div className="kbv-v24-odt-score-values">
              <div className={`kbv-v24-odt-odds ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div className={`kbv-v24-odt-odds ${trendClass(item.trend2)}`}>
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        <div>
          <div className="kbv-v24-odt-label">AOS</div>
          <div className="kbv-v24-odt-score-values">
            <div className="kbv-v24-odt-odds">-</div>
          </div>
        </div>
      </div>
    </div>
  );
}
